export default __webpack_public_path__ + "408dbdb50a5db038b086535ddf003d0d.png";